module.exports = __webpack_public_path__ + "img/green-left.5a498ea8.png";